import React from 'react';

// Parents
import ProjectsRoutes from './dash-projects-routes';

export default function (props) {

  return (
      <ProjectsRoutes />
  )
}
